<template>
  <article class="modal_password">
    <section class="modal_password__modal">
      <div class="modal_password__modal__info">
        <h5 style="margin-bottom:10px;">Exportar a Excel</h5>
        <p style="margin-bottom:10px;">Seleccione el mes que desea exportar</p>
        <input id="fecha" @input="errorMessage=''" v-model="fecha" type="month">
        <select style="margin-top: 5px; width: 220px" v-model="Contract">
          <option value="">Seleccione un contrato</option>
          <option :value="value" v-for="(value, key) in Contracts" :key="key">
            {{value.name}}
          </option>
        </select>
        <h5  class="login__sect-right__form--error" style="font-size: 13px; font-family: Inter UI Regular">{{errorMessage}}</h5>
      </div>
      <div class="modal_password__modal__buttons">
        <button @click="onActivateModal" class="modal_password__modal__buttons--left">
          EXPORTAR
        </button>
        <button @click="onCancelModal" class="modal_password__modal__buttons--right">
          CANCELAR
        </button>
      </div>
    </section>
  </article>
</template>

<script>
import moment from 'moment'
export default {
  data(){
    return{
      fecha:"",
      errorMessage:"",
      Contracts: [],
      Contract: null
    }
  },
  methods:{
    onCancelModal(event){
      this.$emit('cancel', false);
    },
    onActivateModal(event){
      if (this.Contract != null) {
        if (this.fecha){
          this.$emit('activate', {
            fecha: this.fecha,
            Contrato: this.Contract
          })
        }else{
          this.errorMessage="No ha seleccionado una fecha"
        }
      }else{
        alert('Debe selecciona un contrato')
      }
      
      
    },
    getContratacs(){
      const customActions={
        get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
      };
      this.$resource('company',{},customActions).get({"id_card":JSON.parse(localStorage.getItem('user')).id_card})
      .then(function(data){
        console.log('Contratos', data)
        this.Contracts = data.body;
      }).catch(function(err){
        console.log('Error al consultar los contratos: ', err)
    });
    }
  },
  mounted(){
    document.getElementById("fecha").value= moment().format('YYYY-MM');
    this.fecha= moment().format('YYYY-MM');
  },
  created() {
    this.getContratacs();
  },
}
</script>


// WEBPACK FOOTER //
// src/components/shared/ModalExport.vue